<template>
  <v-navigation-drawer v-model="drawer"
                       v-if="user"
                       app
                       fixed
                       disable-resize-watcher
                       disable-route-watcher
                       v-bind="$attrs">
    <template v-slot:prepend>
      <div class="px-2 d-flex align-center"
           style="height: 64px;"
           :style="$root.appBarStyle">
        <v-img :src="$root.appBarLogo"
               alt="Mobile Locker"
               max-height="48"
               contain/>
      </div>
    </template>
    <div class="d-flex flex-column justify-space-between">
      <v-list dense
              nav>

        <v-list-item :to="{name: 'library.home'}"
                     :class="{ 'v-list-item--active': $route.name === 'library.home' }"
                     exact>
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-books
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Content Library
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="canUseBuilder">
          <v-list-item :to="{name: `${$root.routePrefix}.slide_deck.create`}">
            <v-list-item-icon>
              <v-icon>
                fab fa-fw fa-slideshare
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Presentation Builder
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="1===2"
                       :to="{name: 'library.legacy.presentation.builder'}"
                       exact
                       title="Legacy Presentation Builder">
            <v-list-item-icon>
              <v-icon>
                fas fa-fw fa-puzzle-piece
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Legacy Presentation Builder
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-if="canUseDashboard"
                     :to="{name: 'library.user.dashboard'}">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-tachometer-alt-fast
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              My Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="canSendMessages">
          <v-list-item :to="{name: 'library.messaging.index'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-comments
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <span>
                  Send Text Messages
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="canSendEmail">

          <v-list-item v-if="canComposeEmails || isEmailComposerEnabled"
                       :to="{name: 'library.send.email'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-paper-plane
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <span>
                  Send Emails
                </span>
                <v-chip v-if="isEmailComposerEnabled === false"
                        color="success"
                        x-small
                        label
                        class="ml-2">
                  NEW
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isEmailComposerEnabled === false"
                       :to="{name: 'library.email.wizard'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-paper-plane
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Send Email
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canUseSnippets"
                       :to="{name: 'library.snippets.index'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-cut
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Email Snippets
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canUseContacts"
                       :to="{name: 'library.user_contacts.index'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-address-book
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Contacts
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="canUseCampaign">
            <v-list-item :to="{name: 'library.mailcoach.lists'}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-users
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Email Lists
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'library.mailcoach.campaigns'}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-bullhorn
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Campaigns
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </template>

          <v-list-item v-if="canUseSentEmails"
                       :to="{name: 'library.mailgun.messages'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-inbox-out
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Sent Emails
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-if="team.sharing_enabled"
                     :to="{name: 'library.shared_links.index'}">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-external-link
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              My Shared Links
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="canManageShareTemplates">
          <v-list-item :to="{name: 'library.share_templates.index'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-envelope
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Email Templates
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="canManageDeviceSessions">
          <v-list-item :to="{name: 'library.device_sessions'}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-list
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Sessions
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="canSendFaxes">
          <v-list-item :to="{name: `${$root.routePrefix}.fax.home`}">
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-fax
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Faxes
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-if="canUseMetabase"
                     @click.stop="openMetabase"
                     href="#">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-chart-line
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Metabase
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </div>
    <template v-slot:append>
      <v-list dense
              nav>
        <v-divider></v-divider>
        <HelpMenuItem>
        </HelpMenuItem>
        <FeedbackMenuItem>
        </FeedbackMenuItem>
        <v-list-item :to="{name: `${$root.routePrefix}.edit_profile`}">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-id-badge
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Edit My Profile
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="teams.length > 1"
                     @click.prevent="openSwitchTeamDialog">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-building
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Switch Teams
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="isAdmin">
          <v-list-item href="/admin/presentations"
                       target="_blank"
                       exact>
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-cogs
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Administration
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item @click.prevent="logout">
          <v-list-item-icon>
            <v-icon>
              fal fa-fw fa-sign-out
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Sign Out
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <SwitchTeamDialog v-if="switchTeamDialog"
                      :dialog="switchTeamDialog"
                      @close="switchTeamDialog">
    </SwitchTeamDialog>
  </v-navigation-drawer>
</template>
<script>
import {mapGetters} from 'vuex';
import axios from '../../../services/axiosService';
import contentService from '../../../services/contentService';
import HelpMenuItem from '../../../components/HelpMenuItem';
import FeedbackMenuItem from "../../../components/FeedbackMenuItem";
import SwitchTeamDialog from '../../teams/components/SwitchTeamDialog.vue';
import metabaseService from '../../../services/metabaseService';

export default {
  name: 'content-drawer',
  components: {SwitchTeamDialog, FeedbackMenuItem, HelpMenuItem},
  data() {
    return {
      items: [
        {
          title: 'Content',
          active: false,
          items: [],
        }
      ],
      switchTeamDialog: false, // MLD-7934
    }
  },
  computed: {
    ...mapGetters([
      'canComposeEmails', // MLD-6403
      'canManageDeviceSessions', // MLD-3922
      'canManageShareTemplates', // MLD-3150
      'canSendEmail', // MLD-3917
      'canSendFaxes', // MLD-3917
      'canSendMessages', // MLD-7490
      'canUseBuilder', // MLD-2882
      'canUseCampaign', // MLD-3917
      'canUseContacts', // MLD-3922
      'canUseDashboard', // MLD-3922
      'canUseMetabase', // MLD-8203
      'canUseSentEmails', // MLD-3922
      'canUseSnippets', // MLD-3900
      'impersonating', // MLD-3014
      'isAdmin',
      'isCampaignsEnabled', // MLD-3917
      'isEmailComposerEnabled', // MLD-6403
      'isMember',
      'team',
      'teams', // MLD-7934
      'user',
    ]),
    ...mapGetters('content', [
      'folders',
      'liveMode',
      'presentations',
    ]),
    drawer: {
      get() {
        return this.$store.state.system.drawer;
      },
      set(val) {
        this.$store.commit('setDrawer', val)
      },
    },
    filteredPresentations() {
      return this.presentations.filter(p => p.is_active && !p.type_html);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    launchPresentation(presentation, newTab) {
      contentService.launchPresentation(presentation, newTab, this.$router, this.liveMode);
    },
    fetchData() {
      /*if (this.folders.length === 0) {
        this.$store.dispatch('content/fetchUserFolders');
      }
      if (this.presentations.length === 0) {
        this.$store.dispatch('content/fetchPresentations');
      }*/
    },
    logout() {
      axios.post('/logout')
        .then(() => {
          this.$store.dispatch('logout');
        })
        .finally(() => {
          window.location.assign('/login');
          //this.$router.replace({name: 'login'});
        })
    },
    openSwitchTeamDialog() { // MLD-7934
      this.switchTeamDialog = true;
    },
    closeSwitchTeamDialog() { // MLD-7934
      this.switchTeamDialog = false;
    },
    async openMetabase(e) { // MLD-8203
      try {
        e.preventDefault();
        await metabaseService.openMetabase();
      } catch (e) {
        this.$toast.error('You cannot access Metabase.');
        console.log(e);
      }
    }
  }
}
</script>
